import moment from "moment";
import { countryList } from "../../../../helperFuncs/countryList";
import { useSelector } from "react-redux";

const WalletHistoryCard = ({ data, setdetails, setmodal }) => {
  const { country } = useSelector((state) => state.projectSite);

  return (
    <div className="md:hidden">
      {data && data.length > 0 ? (
        data.map((transaction, index) => (
          <div key={index} className="border rounded-md p-3 mb-3 shadow-sm">
            <div className="flex justify-between items-center mb-2">
              <div className="text-gray-600 text-sm">
                Transaction #{index + 1}
              </div>
              <div
                className={`flex items-center justify-center border-[1px] px-2 py-1 rounded-full ${
                  transaction.action === "debit"
                    ? "border-red-400 text-red-400"
                    : "border-green-500 text-green-500"
                }`}
              >
                {transaction.action}
              </div>
            </div>

            <div className="flex justify-between items-center mb-2">
              <div className="text-gray-600 text-sm">Initiator:</div>
              <div className="font-medium">{transaction.operator}</div>
            </div>

            <div className="flex justify-between items-center mb-2">
              <div className="text-gray-600 text-sm">Amount:</div>
              <div className="font-medium">
                {transaction.amount.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}{" "}
                {countryList[country]["Currency Code"]}
              </div>
            </div>

            <div className="flex justify-between items-center">
              <div className="text-gray-600 text-sm">Date:</div>
              <div className="text-sm">
                {moment(transaction.transactionDate).format("lll")}
              </div>
            </div>

            {/* Uncomment if you want to add a view button
            <div className="mt-3 text-center">
              <button
                className="border-[1px] rounded border-secondary text-[12px] text-secondary font-light px-4 py-2 w-full"
                onClick={() => setdetails(transaction)}
              >
                View Details
              </button>
            </div>
            */}
          </div>
        ))
      ) : (
        <div className="text-center py-5 text-gray-500">
          No transaction history available
        </div>
      )}
    </div>
  );
};

export default WalletHistoryCard;
